import { render, staticRenderFns } from "./GeraLinkZenDesk.vue?vue&type=template&id=012bebab&"
import script from "./GeraLinkZenDesk.vue?vue&type=script&lang=js&"
export * from "./GeraLinkZenDesk.vue?vue&type=script&lang=js&"
import style0 from "./GeraLinkZenDesk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports